// Generated by @nuxtjs/svg-sprite
export const sprites = {
  "img": () => import("/builds/kassir/website/assets/sprite/gen/img.svg").then(r => r.default || r),
  "icon": () => import("/builds/kassir/website/assets/sprite/gen/icon.svg").then(r => r.default || r),
  "outline": () => import("/builds/kassir/website/assets/sprite/gen/outline.svg").then(r => r.default || r),
  "solid": () => import("/builds/kassir/website/assets/sprite/gen/solid.svg").then(r => r.default || r)
}
export const spriteClass = "";

export const spriteClassPrefix = "";

export const defaultSprite = "icons";
